<script setup>
import { validationCheck, regex } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import Main from './Main.vue'
import ButtonSubmit from './ButtonSubmit.vue'
import HoursEdit from '@views/settings/HoursEdit.vue'
import { onMounted } from 'vue'

const saveBusinessHours = async () => {
    Log('working hours', $settings.businessHours)
    const saved = await $settings.saveSettings('business_hours', $settings.businessHours)
    Log('saved', saved)
    Toast.success('Business Hour Updated')
    prebook_admin.setup.hours_updated = true

    router.push({ name: 'dashboard' })
}

onMounted(() => {
    $settings.fetchSettings()
})
</script>

<template>
    <Main :title="`Set ${$settings.addons.staffs ? 'Business' : 'Working'} Hours`" :progress="100">
        <HoursEdit />


        <template #footer>
            <ButtonSubmit @click="saveBusinessHours()" />
        </template>
    </Main>
</template>